import { SCREENS_KEYS } from 'constants/constants';
import type { OptionTab } from './models/option-tab';

export const optionTabsCustomers: OptionTab[] = [
  {
    name: 'Administraci\u00F3n',
    path: '/clientes',
    screenKey: SCREENS_KEYS.administration,
    value: 0,
    status: true,
  },
  {
    name: 'Nuevo cliente',
    path: '/clientes/onboarding',
    screenKey: SCREENS_KEYS.newClient,
    value: 1,
    status: true,
  },
  {
    name: 'Carga masiva',
    path: '/clientes/carga-masiva',
    screenKey: SCREENS_KEYS.massUpload,
    value: 2,
    status: true,
  },
  {
    name: 'Admin. de firmas',
    path: '/clientes/administracion',
    value: 3,
    status: false,
  },
];

export const optionTabsFunds: OptionTab[] = [
  {
    name: 'Administraci\u00F3n',
    path: '/fondos',
    screenKey: SCREENS_KEYS.administration,
    value: 0,
    status: true,
  },
];

export const optionTabsPortfolioAndStrategies: OptionTab[] = [
  {
    name: 'Portafolios',
    path: '/portafolio-modelo/portafolios',
    screenKey: SCREENS_KEYS.portfolio,
    value: 0,
  },
  {
    name: 'Estrategias',
    path: '/portafolio-modelo/estrategia',
    screenKey: SCREENS_KEYS.strategy,
    value: 1,
  },
  {
    name: 'Restricciones',
    path: '/portafolio-modelo/restricciones',
    screenKey: SCREENS_KEYS.restrictions,
    value: 2,
  },
  {
    name: 'Rebalanceo',
    path: '/portafolio-modelo/rebalanceo',
    screenKey: SCREENS_KEYS.balancing,
    value: 3,
  },
];

export const optionTabsRebalanceFunds: OptionTab[] = [
  {
    name: 'Portafolios',
    path: '/portafolio-fondos/portafolios',
    screenKey: SCREENS_KEYS.portfolio,
    value: 0,
  },
  {
    name: 'Estrategias',
    path: '/portafolio-fondos/estrategia',
    screenKey: SCREENS_KEYS.fundsStrategy,
    value: 1,
  },
  {
    name: 'Restricciones',
    path: '/portafolio-fondos/restricciones',
    screenKey: SCREENS_KEYS.restrictions,
    value: 2,
  },
  {
    name: 'Rebalanceo',
    path: '/portafolio-fondos/rebalanceo',
    screenKey: SCREENS_KEYS.balancing,
    value: 3,
  },
];

export const optionTabsReport: OptionTab[] = [
  {
    name: 'Operativo',
    path: '/portafolio-modelo/reportes-operacion',
    screenKey: SCREENS_KEYS.operationReports,
    value: 0,
  },
  {
    name: 'Inversi\u00F3n',
    path: '/portafolio-modelo/inversion',
    screenKey: SCREENS_KEYS.investment,
    value: 1,
  },
  {
    name: 'Honorarios',
    path: '/portafolio-modelo/honorarios',
    screenKey: SCREENS_KEYS.fee,
    value: 2,
  },
  {
    name: 'Documental',
    path: '/portafolio-modelo/documental',
    screenKey: SCREENS_KEYS.documentary,
    value: 3,
  },
  {
    name: 'Fondos',
    path: '/portafolio-modelo/fondos',
    screenKey: SCREENS_KEYS.reportsFounds,
    value: 4,
  },
  {
    name: 'Liquidez',
    path: '/portafolio-modelo/reporte-liquidez',
    screenKey: SCREENS_KEYS.liquidityReport,
    value: 5,
  },
];

export const optionTabsAdministration: OptionTab[] = [
  {
    name: 'Operaciones',
    path: '/cumplimiento/operaciones',
    screenKey: SCREENS_KEYS.complianceOperaciones,
    value: 0,
  },
  {
    name: 'Listas Restringidas',
    path: '/cumplimiento/restringidos',
    screenKey: SCREENS_KEYS.complianceRestringidos,
    value: 1,
  },
  {
    name: 'Servicios',
    path: '/cumplimiento/servicios',
    screenKey: SCREENS_KEYS.complianceServices,
    value: 2,
  },
  {
    name: 'Auditorias',
    path: '/cumplimiento/auditorias',
    screenKey: SCREENS_KEYS.complianceAudits,
    value: 3,
  },
  {
    name: 'Prácticas de venta',
    path: '/cumplimiento/practicas-venta',
    screenKey: SCREENS_KEYS.complianceSales,
    value: 4,
  },
  {
    name: 'Riesgo',
    path: '/cumplimiento/riesgo',
    screenKey: SCREENS_KEYS.complianceRiskAssessment,
    value: 5,
  },
  {
    name: 'Operaciones Inusuales',
    path: '/cumplimiento/operaciones-inusuales',
    screenKey: SCREENS_KEYS.complianceUnusualOperations,
    value: 6,
  },
  {
    name: 'EBR',
    path: '/cumplimiento/ebr',
    screenKey: SCREENS_KEYS.complianceRiskAssessmentEbr,
    value: 7,
  },
  {
    name: 'Alertas',
    path: '/cumplimiento/alertas',
    screenKey: SCREENS_KEYS.complianceAlertLog,
    value: 8,
  },
  {
    name: 'Reportes de operatividad',
    path: '/cumplimiento/reportes-operatividad',
    screenKey: SCREENS_KEYS.complianceOperationalReports,
    value: 9,
  },
  {
    name: 'Denuncias',
    path: '/cumplimiento/denuncias',
    screenKey: SCREENS_KEYS.complianceComplaints,
    value: 10,
  },
  {
    name: 'Montos operados',
    path: '/cumplimiento/montos-operados',
    screenKey: SCREENS_KEYS.complianceOperatedAmounts,
    value: 11,
  },
  {
    name: 'Alertas operativas',
    path: '/cumplimiento/alertas-operativas',
    screenKey: SCREENS_KEYS.complianceOperationalAlerts,
    value: 12,
  },
];

export const doNotShowTab = [
  '/apoderados',
  '/configuracion',
  '/archivos/operacion',
  '/clientes/cotitular/nuevo',
  '/clientes/nuevo',
  '/clientes/moral/nuevo',
  '/clientes/fideicomiso',
  '/clientes/fideicomiso/nuevo',
];

export const doNotShowTabBySome = [
  '/clientes/fisica/',
  '/clientes/moral/',
  '/clientes/fideicomiso/',
];

export const TAB_GROUPS: OptionTab[][] = [
  optionTabsPortfolioAndStrategies,
  optionTabsRebalanceFunds,
  optionTabsCustomers.filter((tab) => tab.status),
  optionTabsFunds.filter((tab) => tab.status),
  optionTabsAdministration,
  optionTabsReport,
];
